export const ACTIVE_YEAR = 2026;

export const END_SCHOOL_YEAR = '05/31';

export const START_SCHOOL_YEAR = '06/01';

export const BACKEND_URL = (() => {
  switch (process.env.REACT_APP_STAGE) {
    case 'development':
      return 'http://localhost:3011';
    case 'qa':
      return 'https://qa-libot.back3nd.xyz';
    default:
      return 'https://libots.back3nd.xyz';
  }
})();

export const RESOURCES = `${BACKEND_URL}/resources`;

export const ROLES = {
  admin: 'Admin',
  manage: 'Quản lý',
  member: 'Thành viên',
};

export const DOCUMENTS = [
  {
    key: 'isbnCode',
    no: 1,
    format: 'string',
    name: 'Mã ISBN',
  },
  {
    key: 'name',
    no: 2,
    required: true,
    type: 'document',
    format: 'string',
    name: 'Nhan đề',
  },
  {
    key: 'parallelTitle',
    no: 3,
    format: 'string',
    name: 'Nhan đề song song',
  },
  {
    key: 'subTitle',
    no: 4,
    format: 'string',
    name: 'Phụ đề',
  },
  {
    key: 'authorId',
    no: 5,
    required: true,
    format: 'string',
    autoCreate: true,
    isCatalog: true,
    type: 'document',
    name: 'Tác giả chính',
    code: 'authors',
  },
  {
    key: 'sameAuthor',
    no: 6,
    format: 'array',
    name: 'Đồng tác giả',
    code: 'authors',
  },
  {
    key: 'translator',
    no: 7,
    format: 'string',
    name: 'Người biên dịch',
  },
  {
    key: 'resInfo',
    no: 8,
    format: 'string',
    name: 'Thông tin trách nhiệm',
  },
  {
    key: 'content',
    no: 9,
    format: 'string',
    name: 'Tóm tắt nội dung',
  },
  {
    key: 'schoolLevel',
    no: 10,
    format: 'string',
    name: 'Cấp học',
    code: 'levels',
  },
  {
    key: 'grade',
    no: 11,
    format: 'string',
    name: 'Khối học',
    code: 'grades',
  },
  {
    key: 'subjectTypeId',
    no: 12,
    format: 'string',
    required: true,
    name: 'Môn loại',
    isCatalog: true,
    code: 'subjectTypes',
  },
  {
    key: 'categoryId',
    no: 13,
    format: 'string',
    required: true,
    isCatalog: true,
    name: 'Loại ấn phẩm',
    code: 'categories',
  },
  {
    key: 'storageType',
    no: 14,
    format: 'string',
    required: true,
    name: 'Dạng lưu trữ',
    code: 'storageTypes',
  },
  {
    key: 'language_override',
    no: 15,
    format: 'string',
    name: 'Ngôn ngữ',
    code: 'languages',
  },
  {
    key: 'keyword',
    no: 16,
    format: 'array',
    name: 'Từ khoá',
  },
  {
    key: 'topic',
    no: 17,
    format: 'string',
    name: 'Chủ đề',
  },
  {
    key: 'chapInfo',
    no: 18,
    format: 'string',
    name: 'Thông tin tập',
  },
  {
    key: 'sol',
    no: 19,
    format: 'string',
    name: 'Tùng thư',
  },
  {
    key: 'producerId',
    no: 20,
    required: true,
    format: 'string',
    name: 'Nhà xuất bản',
    isCatalog: true,
    code: 'producer',
  },
  {
    key: 'pop',
    no: 21,
    required: true,
    format: 'string',
    name: 'Nơi xuất bản',
  },
  {
    key: 'edition',
    no: 22,
    format: 'string',
    name: 'Lần xuất bản',
  },
  {
    key: 'publishYear',
    no: 23,
    required: true,
    format: 'number',
    name: 'Năm xuất bản',
  },
  {
    key: 'pages',
    no: 24,
    required: true,
    format: 'number',
    name: 'Số trang',
  },
  {
    key: 'size',
    no: 25,
    required: true,
    format: 'string',
    name: 'Kích cỡ',
  },
  {
    key: 'price',
    no: 26,
    format: 'number',
    name: 'Giá bìa',
  },
  {
    key: 'attachment',
    no: 27,
    format: 'string',
    name: 'Tài liệu đính kèm',
  },
  {
    key: 'warehouseId',
    no: 28,
    format: 'string',
    name: 'Kho',
    isCatalog: true,
    related: 'storages',
    code: 'warehouses',
  },
  {
    key: 'cabinetId',
    no: 29,
    format: 'Phích',
    name: 'phích',
    isCatalog: true,
    related: 'storages',
    code: 'cabinets',
  },
  {
    key: 'amount',
    no: 30,
    format: 'string',
    name: 'Số lượng',
    related: 'storages',
  },
  {
    key: 'dateAdded',
    no: 31,
    format: 'date',
    name: 'Ngày nhập',
    related: 'storages',
  },
];

export const LISTING = [{
  key: 'name',
  no: 1,
}];

export const POSTER_CABINET = [
  {
    key: 'name',
    name: 'Tên',
    no: 1,
    required: true,
  },
  {
    key: 'short',
    name: 'Ký hiệu',
    no: 2,
    required: true,
  },
  {
    key: 'warehouseId',
    name: 'Kho',
    no: 3,
    required: true,
    isCatalog: true,
    code: 'warehouses',
  },
];

export const WAREHOUSE = [
  {
    key: 'name',
    name: 'Tên',
    no: 1,
    required: true,
  },
  {
    key: 'symbol',
    name: 'Ký hiệu',
    no: 2,
    required: true,
  },
];

export const CATEGORIES = [
  {
    key: 'name',
    no: 1,
  },
  {
    key: 'symbol',
    no: 2,
  },
];

export const SUBJECT_TYPE = [
  {
    key: 'name',
    name: 'Tên',
    no: 1,
    required: true,
  },
  {
    key: 'symbol',
    name: 'Ký hiệu',
    no: 2,
    required: true,
  },
];

export const USERS = [
  {
    key: 'name',
    no: 1,
  },
  {
    key: 'email',
    no: 2,
  },
  {
    key: 'code',
    no: 3,
  },
  {
    key: 'class',
    no: 4,
  },
  {
    key: 'startDate',
    format: 'dateString',
    no: 5,
  },
  {
    key: 'endDate',
    format: 'dateString',
    no: 6,
  },
];

export const MEMBERS = [
  {
    key: 'name',
    no: 1,
  },
  {
    key: 'email',
    no: 2,
  },
  {
    key: 'role',
    code: 'roles',
    no: 3,
  },
];

export const CHILDREN_BOOK = [
  {
    key: 'name',
    name: 'Nhan đề',
    no: 1,
    required: true,
  },
  {
    key: 'subject',
    name: 'Chủ đề',
    no: 2,
    required: true,
  },
  {
    key: 'coverLink',
    name: 'Đường link ảnh bìa',
    no: 3,
    required: true,
  },
  {
    key: 'bookLink',
    name: 'Đường link sách online',
    no: 4,
    required: true,
  },
  {
    key: 'isPublic',
    name: 'Công khai',
    no: 5,
  },
];

export const DEFAULT_CATEGORIES = [
  {
    name: 'Sách giáo khoa',
    symbol: 'SGK',
  },
  {
    name: 'Sách nghiệp vụ (giáo viên)',
    symbol: 'SNV',
  },
  {
    name: 'Sách tham khảo',
    symbol: 'STK',
  },
  {
    name: 'Sách thiếu nhi',
    symbol: 'STN',
  },
];

export const DEFAULT_LANGUAGE = {
  en: {
    label: 'Tiếng Anh',
    code: 'en',
  },
  fr: {
    label: 'Tiếng Pháp',
    code: 'fr',
  },
};

export const ONLINE_BOOK = [
  {
    key: 'name',
    name: 'Nhan đề',
    no: 1,
    required: true,
  },
  {
    key: 'subtitle',
    name: 'Phụ đề',
    no: 2,
  },
  {
    key: 'coverLink',
    name: 'Đường link bìa sách',
    no: 3,
  },
  {
    key: 'bookLink',
    name: 'Đường link sách',
    no: 4,
    required: true,
  },
  {
    key: 'isPublic',
    name: 'Công khai',
    no: 5,
  },
  {
    key: 'tags',
    name: 'Tags',
    no: 6,
  },
];
